<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Role</th>
                    <th></th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="team in teams" :key="teams.id">
                    <td>{{ team.name }}</td>
                    <td>{{ ucFirst(team.pivot.role) }}</td>
                    <td>
                        <img
                            src="/assets/img/ch-favicon.png"
                            title="User has clickhint installed"
                            v-if="user.has_clickhint_extension"
                            height="15"
                            width="15"
                        />
                    </td>
                    <td>
                        <div class="dropdown show" v-if="!partner">
                            <a
                                href="#"
                                class="d-block d-md-flex text-center settings-link dropdown-toggle align-items-center"
                                role="button"
                                id="dropdownMenuLink"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i
                                    class="fa fa-cog brand-primary-gradient mr-2"
                                ></i>
                                <span>Manage </span>
                            </a>

                            <div
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuLink"
                            >
                                <a
                                    href="#"
                                    @click.prevent="changeRole(user, team)"
                                    class="dropdown-item"
                                >
                                    <i class="fa fa-user mr-2"></i>
                                    Turn into
                                    {{
                                        team.pivot.role == "member"
                                            ? "owner"
                                            : "member"
                                    }}
                                </a>
                                <a
                                    href="#"
                                    @click.prevent="remove(user, team)"
                                    class="dropdown-item"
                                >
                                    <i class="fa fa-times mr-2"></i>
                                    Remove from team
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import AdministrationMixin from "../AdministrationMixin";
export default {
    props: {
        teams: Array,
        user: {
            Object,
            required: true
        }
    },
    mixins: [AdministrationMixin],

    data() {
        return {};
    },

    computed: {},
    methods: {
        changeRole(user, team) {
            axios
                .put(`/api/admin/change-user-role/${team.id}/${user.id}`, {})
                .then(response => {
                    this.$parent.$emit("user-update-triggered", true);
                });
        },
        remove(user, team) {
            //
            swal(
                {
                    title: `Are you sure you want to remove ${user.name} from ${
                        team.name
                    }?`,
                    text: "The action will be applied right away!",
                    icon: "danger",
                    showCancelButton: true,
                    confirmButtonColor: "#cd3537",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Remove"
                },
                async result => {
                    if (result) {
                        axios
                            .delete(
                                `/api/admin/delete-team-user/${team.id}/${
                                    user.id
                                }`
                            )
                            .then(response => {
                                this.$parent.$emit(
                                    "user-update-triggered",
                                    true
                                );
                            });
                    }
                }
            );
        }
    },
    mounted() {}
};
</script>
